import { HttpHeaders } from '@angular/common/http';
import { computed, effect, inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { v4 as generateUuidV4 } from 'uuid';

/**
 * Service for managing tracing configuration.
 */
@Injectable({
  providedIn: 'root',
})
export class TracingService {
  private readonly logger = inject(NGXLogger);

  readonly parentCavorsSessionId: WritableSignal<string | undefined> = signal(undefined);

  readonly sessionId = computed(() => this.parentCavorsSessionId() ?? this.getOrSetSessionIdFromSessionStorage());

  readonly tracingHeaders: Signal<Map<string, string>> = computed(() => {
    return new Map([['cavors-session-id', this.sessionId()]]);
  });

  protected readonly tracingHeadersUpdate = effect(() => {
    const tracingHeaders = this.tracingHeaders();
    if (tracingHeaders) {
      let headers = this.logger.getConfigSnapshot().customHttpHeaders ?? new HttpHeaders();
      tracingHeaders.forEach((value, key) => (headers = headers.set(key, value)));
      this.logger.partialUpdateConfig({ customHttpHeaders: headers });
    }
  });

  private getOrSetSessionIdFromSessionStorage(): string {
    const key = 'cavors-session-id';

    let sessionId = sessionStorage.getItem(key);
    if (!sessionId) {
      sessionId = generateUuidV4();
      sessionStorage.setItem(key, sessionId);
    }
    return sessionId;
  }
}
